import axios from 'axios';

const API_URL = `${process.env.REACT_APP_SERVER}/auth`;

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
});

// Add request interceptor
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add response interceptor
api.interceptors.response.use(
  response => response,
  error => {
    // Only redirect if it's not a login attempt (login endpoint will handle its own errors)
    if ((error.response?.status === 401 || error.response?.status === 403) && 
        !error.config.url.includes('/login')) {
      localStorage.removeItem('token');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

export const login = async (email, password) => {
  console.log()
  const response = await api.post('/login', { email, password });
  return response.data;
};

export const getUserInfo = async () => {
  const response = await api.get('/user');
  return response.data;
};